export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === from.path) return
  const { clear } = useLanguageSwitcherStore()
  clear()
})
